import React, { useContext } from "react";
import { Box, ListItem, ListItemText } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { getColors } from "../../themes/theme";
import { FilterCheckbox } from "./Filter/FilterCheckbox";

export const MainList = ({
  isPhaseChecked,
  isTreatmentChecked,
  isCitationChecked,
  isExerciseChecked,
  isLifeStyleChecked,
  isEstimationChecked,
  onPhaseChange,
  onTreatmentChange,
  onCitationChange,
  onExerciseChange,
  onLifeStyleChange,
  onEstimationChange,
}) => {
  const { mainId, careId, subId } = useParams();
  const navigate = useNavigate();
  const handleItemClick = (selectedId) => {
    navigate(`/care-plan/${selectedId}`);
  };
  const { darkMode } = useContext(ThemeContext);

  const careplanMenu = [
    // {
    //   id: "default-phases",
    //   title: "Default Phases",
    // },
    {
      id: "estimation",
      title: "Good Faith Estimation",
    },
    {
      id: "new-plan",
      title: "New Care Plan",
    },
  ];

  return (
    <Box
      sx={{
        display: { xs: "none", md: "block" },
        width: { md: "270px", lg: "320px" },
        height: "100%",
        px: "20px",
        pt: 2,
        borderRight: `1px solid ${
          darkMode ? getColors.appBarBorderDark : getColors.appBarBorderLight
        }`,
      }}
    >
      {careplanMenu.map((item, index) => (
        <ListItem
          key={index}
          onClick={() => handleItemClick(item.id)}
          sx={{
            fontSize: "22px",
            width: { md: "230px", lg: "280px" },
            mb: 1,
            px: "28px",
            py: "14px",
            background:
              mainId === item.id ? getColors.listItemHoverBg : "transparent",
          }}
        >
          <ListItemText
            primary={item.title}
            sx={{
              "& .MuiListItemText-primary": {
                color: mainId === item.id && getColors.primaryTextDark,
              },
            }}
          />
        </ListItem>
      ))}
      <Box
        mt={2}
        display={
          (mainId === "new-plan" &&
            careId !== undefined &&
            subId !== undefined) ||
          careId === "modify" ||
          careId === "copy"
            ? "block"
            : "none"
        }
      >
        <FilterCheckbox
          isPhaseChecked={isPhaseChecked}
          isTreatmentChecked={isTreatmentChecked}
          isCitationChecked={isCitationChecked}
          isExerciseChecked={isExerciseChecked}
          isLifeStyleChecked={isLifeStyleChecked}
          isEstimationChecked={isEstimationChecked}
          onPhaseChange={onPhaseChange}
          onTreatmentChange={onTreatmentChange}
          onCitationChange={onCitationChange}
          onExerciseChange={onExerciseChange}
          onLifeStyleChange={onLifeStyleChange}
          onEstimationChange={onEstimationChange}
        />
      </Box>
    </Box>
  );
};
